module.exports = __webpack_public_path__ + "img/step5.55d384ca.png";